import React, { ReactNode } from 'react';

import { Modal, ModalProps } from '@mui/material';
import { isUndefined } from 'lodash';

import { Spinner, YesNoBtnRow, YesNoBtnRowProps } from '@infoods/lifebase-ui';

import classes from './LbBigModal.module.scss';
import { ScrollBox } from '../../ui-components';

type LbModalProps = {
  title: string;
  description?: ReactNode;
  children: ReactNode;
  buttonOptions?: Omit<YesNoBtnRowProps, 'children' | 'size'>;
  extraButton?: ReactNode;
  isLoading?: boolean;
  renderButtonRow?: ReactNode;
  /** false - children render without the modal's `ScrollBox`, for content that scrolls only a part of itself */
  withScrollBox?: boolean;
} & Pick<ModalProps, 'open' | 'onClose'>;

const LbBigModal = ({
  open,
  title,
  description,
  children,
  onClose,
  buttonOptions = {},
  extraButton,
  isLoading = false,
  renderButtonRow,
  withScrollBox = true,
}: LbModalProps) => {
  return (
    <Modal open={open} onClose={onClose}>
      <div className={classes.modalPaper}>
        <div className={classes.modalInfo}>
          <h3>{title}</h3>
          {description && <p>{description}</p>}
        </div>
        {withScrollBox ? (
          <ScrollBox maxHeight={600} variant="outBox">
            {children}
          </ScrollBox>
        ) : (
          children
        )}
        {isUndefined(renderButtonRow) ? (
          <YesNoBtnRow {...buttonOptions} size="medium">
            {extraButton}
          </YesNoBtnRow>
        ) : (
          renderButtonRow
        )}
        <Spinner isLoading={isLoading} />
      </div>
    </Modal>
  );
};

export { LbBigModal };
